module.exports = __webpack_public_path__ + "static/media/16.914e4e62.wav";